import CannedResponseButton from '../elements/canned-response-button'

export default CannedResponseButton
